










































































































































































































































































































































































































































import Vue from 'vue'
import { vxm } from '@/state'
import Page from '@/components/layouts/Page.vue'

export default Vue.extend({
  name: 'LayoutHelper',

  components: {
    Page,
  },
  props: {
  },
  data: () => ({
    // Please duplicate the colors in dev/layoutHepler.vue
    layoutHelpColors: {
      pageOuterContainer: 'yellow lighten-1',
      content: 'purple lighten-4',
      pageContentContainer: 'green lighten-3',
      pageMainRow: 'orange lighten-4',
      pageMainCol: 'blue lighten-4',
    },
  }),
  computed: {
    cols() {
      const { lg, sm } = this.$vuetify.breakpoint
      // eslint-disable-next-line no-nested-ternary
      return lg ? [3, 9] : sm ? [9, 3] : [6, 6]
    },
    isShowingVisualDesignHelp() {
      return vxm.app.showVisualDesignHelp
    },
  },
  methods: {
    toogleShowVisualDesignHelp() {
      vxm.app.showVisualDesignHelp = !vxm.app.showVisualDesignHelp
    },
  },
})

